<div class="foot-content-center">
      <a href="#" (click)=onFAQOpen($event) title="{{'footer.faq.alt_text' | translate}}">
            {{'footer.faq.label' | translate}}
      </a>
</div>
<light-box input-class="white-box">
      <div style="padding-top:0.5em; padding-right:0.5em; padding-bottom:0">
         <header-x (close)="onMyClose()" ></header-x>
      </div>
      <ng-container *ngComponentOutlet="FAQComponent"></ng-container>
</light-box>

<div class="footer" style="background-color: #dddddd; padding: 0.63em 0; margin-top:1.88em;">

      <div class="foot-item">
            <a-link link-url='footer.about_ontario.URL' alt-text='footer.about_ontario.alt_text' label='footer.about_ontario.label'>
            </a-link>
      </div>
      <div class="foot-item">
            <a-link link-url='footer.accessibility.URL' alt-text='footer.accessibility.alt_text' label='footer.accessibility.label'>
            </a-link>
      </div>
      <div class="foot-item">
            <a-link link-url='footer.news.URL' alt-text='footer.news.alt_text' label='footer.news.label'>
            </a-link>
      </div>
      <div class="foot-item">
            <a-link link-url='footer.privacy.URL' alt-text='footer.privacy.alt_text' label='footer.privacy.label'>
            </a-link>
      </div>

      <div class="foot-item">
            <a-link link-url='footer.terms_of_use.URL' alt-text='footer.terms_of_use.alt_text'
                  label='footer.terms_of_use.label'></a-link>
      </div>

      <div class="foot-print">
            <a-link link-url='footer.queens_printer.URL' alt-text='footer.queens_printer.alt_text'
                  label='footer.queens_printer.label' label-param="{{copyrightYear}}"></a-link>
      </div>

      <div class="foot-inline">
            <div>
                  <img src="refresh/assets/images/ontario-logo.png" 
                       class="footer-logo-left"  [alt]="'footer.ontario_banner.alt_text' | translate"/> 
            </div> 
            <div>
                  <img src="refresh/assets/images/canada-logo-footer.png"  
                       class="footer-logo-right"  [alt]="'footer.canada_banner.alt_text' | translate"/> 
            </div> 
      </div>
</div>
<div alt-text='build-version' style="height:0.2em">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>